<template>
    <div class="layer-container">
        <el-tabs type="border-card" class="box-card" v-model="activeName" @tab-click="tabClick">
            <el-tab-pane name="layer" label="图层管理">
                <!-- <el-card class="box-card">
                    <div slot="header" class="clearfix header">
                        <span>工作区-{{wname}}</span>
                        <div>

                        </div>
                    </div>

                </el-card> -->
                <div class="content">
                    <div class="btns">
                        <el-button type="primary" @click="addLayer" class="submit-btn">新增图层</el-button>
                        <el-button type="primary" @click="layerSortHandle" class="submit-btn">图层排序</el-button>
                    </div>
                    <el-table :data="layerArr" style="width: 100%" border>
                        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                        <el-table-column
                            prop="workspace"
                            label="工作区名称"
                            width="260">
                        </el-table-column>
                        <el-table-column
                            prop="title"
                            label="标题">
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="图层名称">
                        </el-table-column>
                        <el-table-column
                            prop="alias"
                            label="图层别名">
                        </el-table-column>
                        <el-table-column
                            prop="storeName"
                            label="存储空间">
                        </el-table-column>
                        <el-table-column
                            prop="srs"
                            label="坐标系"
                            width="100">
                        </el-table-column>
                        <el-table-column
                            prop="createTime"
                            label="创建时间"
                            width="180">
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="60" align="center">
                            <template slot-scope="scope">
                                <el-button @click="deleteHandle(scope.row)" type="text" size="small">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination class="page" background layout="prev, pager, next" :total="dataTotal" :page-size="pageSize" :current-page.sync="pageNum" @current-change="pageChange"></el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane name="group" label="图层组管理">
                <div class="content">
                    <div class="btns"><el-button type="primary" @click="addLayerGroup" class="submit-btn">新增图层组</el-button></div>
                    <el-table :data="layerGroupArr" style="width: 100%" border>
                        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                        <!-- <el-table-column type="expand">
                        <template slot-scope="props">
                            <el-table
                                :data="props.childrenData"
                                style="width: 100%">
                                <el-table-column
                                    prop="title"
                                    label="标题">
                                </el-table-column>
                                <el-table-column
                                    prop="name"
                                    label="图层名称">
                                </el-table-column>
                                <el-table-column
                                    prop="alias"
                                    label="图层别名">
                                </el-table-column>
                                <el-table-column
                                    prop="storeName"
                                    label="存储空间">
                                </el-table-column>
                            </el-table>
                        </template>
                        </el-table-column> -->
                        <el-table-column
                            prop="workspaceName"
                            label="工作区名称"
                            width="260">
                        </el-table-column>
                        <el-table-column
                            prop="groupName"
                            label="图层组名称">
                        </el-table-column>
                        <el-table-column
                            prop="createTime"
                            label="创建时间"
                            width="180">
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="200" align="center">
                            <template slot-scope="scope">
                                <el-button @click="groupDeleteHandle(scope.row)" type="text" size="small">删除</el-button>
                                <el-button @click="groupDetailHandle(scope.row)" type="text" size="small">图层列表</el-button>
                                <el-button @click="groupEditHandle(scope.row)" type="text" size="small">管理图层</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination class="page" background layout="prev, pager, next" :total="groupDataTotal" :page-size="pageSize" :current-page.sync="groupPageNum" @current-change="groupPageChange"></el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane name="view" label="图层预览">
                <Mapviewer></Mapviewer>
            </el-tab-pane>
        </el-tabs>

        <el-dialog title="图层列表" :visible.sync="dialogLayerVisible">
            <el-table :data="dialogLayerArr" border>
                <el-table-column prop="workspace" label="工作区名称" width="120"></el-table-column>
                <el-table-column prop="title" label="标题"></el-table-column>
                <el-table-column prop="name" label="图层名称" width="200"></el-table-column>
                <el-table-column prop="alias" label="图层别名"></el-table-column>
                <el-table-column prop="storeName" label="存储空间"></el-table-column>
                <el-table-column prop="srs" label="坐标系" width="100"></el-table-column>
                <!-- <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column> -->
            </el-table>
        </el-dialog>
        <el-dialog title="图层列表-拖动排序" :visible.sync="dialogLayerSortVisible" width="800px">
            <div id="dialogListGroupLayer" class="list-group">
                <div :class="'item ' + item.id" v-for="item in dialogSortLayerArr" :key="item.id">{{item.alias}}</div>
            </div>
            <div class="dialog-btns">
                <el-button type="primary" @click="submitSortLayer" class="submit-btn">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Sortable from 'sortablejs'
import Mapviewer from '../mapview/Mapviewer.vue'
import { listLayerByWorkspace, listLayerGroup, listLayerByGroupId, delLayer, deleteLayerGroup, sortLayer } from '../../api/layerApi'
export default {
    name: 'LayerList',
    components: { Mapviewer },
    data() {
        return {
            dialogLayerVisible: false,
            dialogLayerSortVisible: false,
            dialogLayerArr: [],
            dialogSortLayerArr: [],
            wname: undefined,
            wid: undefined,
            layerArr: [],
            layerGroupArr: [],
            activeName: 'layer',
            pageNum: 1,
            pageSize: 10,
            dataTotal: 0,
            groupPageNum: 1,
            groupPageSize: 10,
            groupDataTotal: 0,
            newSortLayerArr: []
        }
    },
    mounted() {
        this.wname = this.$route.query.w
        this.wid = this.$route.query.id
        this.activeName = this.$route.query.type
        this.loadLayerList()
        this.loadLayerGroupList()
    },
    beforeDestroy() {
    },
    methods: {
        submitSortLayer() {
            sortLayer({ ids: this.newSortLayerArr.join(',') }).then(res => {
                this.dialogLayerSortVisible = false
                this.loadLayerList()
            })
        },
        layerSortHandle() {
            var thiz = this
            thiz.dialogLayerSortVisible = true
            listLayerByWorkspace({ pageNum: 1, pageSize: 999, id: this.wid }).then(res => {
                if (res.data.code == 200) {
                    thiz.dialogSortLayerArr = res.data.rows
                    var listGroupLayer = document.querySelector('#dialogListGroupLayer')
                    var sortable = new Sortable(listGroupLayer, {
                        animation: 150,
                        ghostClass: 'blue-background-class',
                        onEnd: function(/** Event*/evt) {
                            thiz.newSortLayerArr = []
                            if (evt.newIndex != evt.oldIndex) {
                                Array.from(evt.to.children).forEach(item => {
                                    thiz.newSortLayerArr.push(item.className.split(' ')[1])
                                })
                            }
                        }
                    })
                }
            })
        },
        groupDetailHandle(item) {
            listLayerByGroupId({ groupId: item.id }).then(res => {
                this.dialogLayerVisible = true
                this.dialogLayerArr = res.data.data
            })
        },
        groupEditHandle(item) {
            this.$router.push('/layer/layerGroup?gi=' + item.id + '&gn=' + item.groupName + '&w=' + this.wname + '&id=' + this.wid + '&t=' + new Date().getTime())
        },
        loadLayerList() {
            listLayerByWorkspace({ pageNum: this.pageNum, pageSize: this.pageSize, id: this.wid }).then(res => {
                if (res.data.code == 200) {
                    this.layerArr = res.data.rows
                    this.dataTotal = res.data.total
                }
            })
        },
        loadLayerGroupList() {
            listLayerGroup({ pageNum: this.groupPageNum, pageSize: this.groupPageSize, workspaceId: this.wid }).then(res => {
                if (res.data.code == 200) {
                    this.layerGroupArr = res.data.rows
                    this.groupDataTotal = res.data.total
                }
            })
        },
        addLayer() {
            this.$router.push('/layer/addLayer?w=' + this.wname + '&id=' + this.wid + '&t=' + new Date().getTime())
        },
        addLayerGroup() {
            this.$router.push('/layer/addLayerGroup?w=' + this.wname + '&id=' + this.wid + '&t=' + new Date().getTime())
        },
        searchSubmit() {
            this.loadLayerList()
        },
        groupDeleteHandle(item) {
            this.$confirm('此操作将永久删除该图层组, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const loading = this.$loading({
                    lock: true,
                    text: '加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                deleteLayerGroup({ groupId: item.id }).then(res => {
                    loading.close()
                    if (res.data.code == 200) {
                        this.loadLayerGroupList()

                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                })
            }).catch(() => {
                console.log('删除失败')
            })
        },
        deleteHandle(item) {
            this.$confirm('此操作将永久删除该图层, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const loading = this.$loading({
                    lock: true,
                    text: '加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })

                delLayer({ id: item.id }).then(res => {
                    loading.close()
                    if (res.data.code == 200) {
                        this.loadLayerList()

                        // 删除左侧菜单子菜单
                        var result = this.$parent.workspaceMenu.filter(i => i.id == this.wid)
                        if (result.length > 0) {
                            var obj = result[0]
                            this.$parent.workspaceMenu.filter(i => {
                                if (i.id === obj.id) {
                                    i.list = obj.list.filter(subItem => subItem.id != item.id)
                                }
                            })
                        }

                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                })
            }).catch(() => {
                console.log('删除失败')
            })
        },
        pageChange(val) {
            this.loadLayerList()
            this.pageNum = val
        },
        groupPageChange(val) {
            this.loadLayerGroupList()
            this.groupPageNum = val
        },
        tabClick(tab, event) {
            if (tab.name == 'layer') {
                this.loadLayerList()
            } else if (tab.name == 'group') {
                this.loadLayerGroupList()
            }
        }
    },
    watch: {
        $route(to, from) {
            this.wname = to.query.w
            this.wid = to.query.id
            this.activeName = to.query.type
            this.loadLayerList()
        }
    }
}
</script>

<style lang="scss" scoped>
/deep/.el-card{
    height: 100% !important;
}
/deep/.el-card__header{
    padding: 20px !important;
}
/deep/.el-tabs__content{
    height: calc(100vh - 200px);
}
.blue-background-class{
    background-color: #f2f2f2;
}
.dialog-btns{
    width: 100%;
    display: flex;
    justify-content: center;
}
.list-group{
    width: 100%;
    height: 500px;
    overflow-y:scroll;
    .item{
        padding: 5px 10px;
        border: 1px solid rgba(0,0,0,.125);
        cursor: pointer;
        padding: 0.75rem 1.25rem;
        margin: 2px;
    }
}
.layer-container {
    background: #f2f2f2;
    height: calc(100vh - 111px);
    .box-card{
        height: 100% !important;
    }
    .content{
        display: flex;
        flex-direction: column;
        align-items: center;
        .btns{
            width: 100%;
            margin-bottom: 10px;
        }

        .page{
            position: absolute;
            bottom: 80px;
        }
    }
}
</style>

